/* eslint-disable react-hooks/exhaustive-deps */
import StarsIcon from '@mui/icons-material/Stars';
import { get, isArray, isEmpty, isNull } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';
import attachment from '../../../../assets/img/attachment.svg';
import avatar from '../../../../assets/img/avatar.svg';
import Thumbnail from '../../../components/ThumbnailComponent';
import PageLoader from '../../../components/loaders/PageLoader';
import { formatPhoneNumber } from '../../../helpers/helper';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { GET, POST } from '../../../services/rest.service';

const NannyView = () => {
  const [nanny, setNanny] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const getNanny = async () => {
    try {
      const nanny = await GET(`/admin/user/get_by_id/${id}`);
      setNanny(nanny.data);
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    getNanny();
  }, []);

  const handleExport = async () => {
    const payload = {
      ids: [nanny._id],
    };
    dispatch(showLoading('Exporting, please wait...'));
    try {
      const res = await POST(`/admin/nanny/export/pdf`, payload, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Nannies-Resume.pdf');
      document.body.appendChild(link);
      link.click();
      dispatch(hideLoading());
    } catch (err) {
      console.log('err', err);
      dispatch(hideLoading());
    }
  };

  if (isEmpty(nanny)) {
    return <PageLoader />;
  }

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-md-12 col-xl-12 col-xll-10  mb-5">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h3 className="h6 text-uppercase mb-0">
                  {nanny.first_name} {nanny.last_name} {nanny.nanny && nanny.nanny.top_nanny && <StarsIcon />}
                  {nanny.nanny && !isEmpty(nanny.nanny.resume) && (
                    <>
                      <img height="18" className="ml-2 mr-1" src={attachment} alt="location" />

                      <a href={get(nanny, 'nanny.resume.document.url')} rel="noopener noreferrer" target="_blank">
                        {get(nanny, 'nanny.resume.resumeFileName')}{' '}
                      </a>
                    </>
                  )}
                </h3>
                <div>
                  <button className="btn btn-outline-primary" onClick={() => navigate(`/admin/nanny/update/${nanny._id}`)}>
                    <i className="fas fa-pen"></i> Edit
                  </button>
                  <button className="btn btn-outline-primary ml-2" onClick={handleExport}>
                    <i className="fas fa-download"></i> Export PDF
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-3">
                    {nanny.nanny && nanny.nanny.profile_picture && (
                      <Thumbnail
                        style={{
                          width: '150px',
                          height: '150px',
                          objectFit: 'cover',
                        }}
                        placeHolderImage={avatar}
                        source={`${nanny.nanny.profile_picture.url}`}
                        className="rounded-circle mx-3 my-2 my-lg-0 img-fluid c-pointer"
                      />
                    )}
                  </div>
                  <div className="col-9">
                    <div className="row">
                      <div className="col-12 col-lg-6 col-xll-6">
                        <div className="row">
                          <div className="col-12">
                            <h4 className="text-400">Contact Info</h4>
                            <hr />
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <i className="fas fa-envelope mr-1"></i> {nanny.email}
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <i className="fas fa-phone mr-1"></i> {formatPhoneNumber(nanny.mobile_number)}
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <i className="fas fa-map-marker-alt mr-1"></i> {nanny.location.address}
                            </div>
                          </div>
                          {nanny.nanny?.residential_address && (
                            <div className="col-12">
                              <div className="form-group mb-0">
                                <i className="fas fa-home mr-1"></i> {nanny.nanny?.residential_address}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-6 col-xll-6">
                        <div className="row">
                          <div className="col-12">
                            <h4 className="text-400">Other Details</h4>
                            <hr />
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <i className="fas fa-calendar-alt mr-1"></i>
                              DOB: {nanny.nanny && nanny.nanny.date_of_birth && moment(nanny.nanny.date_of_birth).format('MMM DD, YYYY')}
                            </div>
                          </div>
                          {/* <div className="col-12">
                            <div className="form-group">
                              <i className="fas fa-id-card mr-1"></i>
                              SSN: {nanny.nanny && nanny.nanny.social_security_number && nanny.nanny.social_security_number}
                            </div>
                          </div> */}
                          <div className="col-12">
                            <div className="form-group">
                              <i className="fas fa-sticky-note mr-1"></i>
                              Note: {nanny.nanny && nanny.nanny.note && nanny.nanny.note}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 mt-5">
                        <h4 className="text-400">Skills</h4>
                        <hr />
                      </div>
                      <div className="d-flex account-skill-list">
                        {/*SKILLS*/}
                        <ul className="list-inline mb-0">
                          {nanny.nanny &&
                            isArray(nanny.nanny?.skills) &&
                            nanny.nanny.skills.map((x, index) => {
                              return (
                                <li key={index} className="list-inline-item mr-0">
                                  <Thumbnail style={{ width: '30px' }} className={'img-fluid mb-2 mr-2'} source={`${x.skill_id.icon.url}`} />
                                  {x.skill_id.title}
                                </li>
                              );
                            })}
                          {nanny.nanny &&
                            isArray(nanny.nanny.other_skills) &&
                            nanny.nanny.other_skills.map((x, index) => {
                              return (
                                <li key={index} className="list-inline-item mr-0">
                                  {x.title}
                                </li>
                              );
                            })}
                        </ul>
                      </div>

                      {/*DOCS*/}
                      <div className="col-12 mt-4">
                        <h4 className="text-400">Qualification</h4>
                        <hr />
                      </div>
                      <div className="d-flex account-skill-list">
                        <ul className="list-inline mb-0">
                          {nanny.nanny &&
                            isArray(nanny.nanny.skills) &&
                            nanny.nanny.skills.map((x, index) => {
                              return (
                                <li key={index} className="list-inline-item mr-0">
                                  <a className="text-dark" target="_blank" href={x.document && x.document.url} rel="noreferrer">
                                    <i className={'far fa-file-alt mr-2'}></i>
                                    {x.skill_id.title}
                                  </a>
                                </li>
                              );
                            })}
                          {nanny.nanny &&
                            isArray(nanny.nanny.other_skills) &&
                            nanny.nanny.other_skills.map((x, index) => {
                              return (
                                <li key={index} className="list-inline-item mr-0">
                                  <a className="text-dark" target="_blank" href={x.document && x.document.url} rel="noreferrer">
                                    <i className={'far fa-file-alt mr-2'}></i>
                                    {x.title}
                                  </a>
                                </li>
                              );
                            })}
                        </ul>
                      </div>

                      <div className="col-12 mt-4">
                        <h4 className="text-400">Education</h4>
                        <hr />
                      </div>
                      <div className="col-12 col-lg-6 d-flex account-skill-list">
                        <ul className="">
                          {nanny.nanny &&
                            !isNull(nanny.nanny.education) &&
                            nanny.nanny.education.map((x, index) => {
                              return (
                                <li key={index} className="pb-0 pl-0">
                                  {x}
                                </li>
                              );
                            })}
                        </ul>
                      </div>

                      <div className="col-12 mt-4">
                        <h4 className="text-400">Experience</h4>
                        <hr />
                      </div>
                      <div className="col-12 col-lg-6 d-flex account-skill-list">
                        <ul className="">
                          {nanny.nanny &&
                            !isNull(nanny.nanny.experience) &&
                            nanny.nanny.experience.map((x, index) => {
                              return (
                                <li key={index} className="pb-0 pl-0">
                                  {x}
                                </li>
                              );
                            })}
                        </ul>
                      </div>

                      {/*Refs*/}
                      <div className="col-12 mt-4">
                        <h4 className="text-400">References</h4>
                        <hr />
                      </div>
                      <div className="d-flex account-skill-list">
                        <ul className="list-inline mb-0">
                          {nanny.nanny &&
                            !isNull(nanny.nanny.reference) &&
                            nanny.nanny.reference.map((x, index) => {
                              return (
                                <li key={index} className="list-inline-item mr-0">
                                  {x.name}
                                  <span className="d-block text-gray">{x.phone_number}</span>
                                  <span className="d-block text-gray">{x.email}</span>
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                      <div className="col-12 mt-4">
                        <h4 className="text-400">About me</h4>
                        <hr />
                      </div>
                      {nanny.nanny && nanny.nanny.about_nanny && (
                        <div
                          className="col-12"
                          dangerouslySetInnerHTML={{
                            __html: nanny.nanny.about_nanny,
                          }}
                        ></div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NannyView;
